// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"227":"b52d3e634827124e","548":"6d7b841a42ece102"}[chunkId] + ".js";
};